import { Observable, of } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import BPCAbstractRequestService from './bpc-abstract-request.service';
import axios from 'axios';
import BPCApiRouteService from '@core/services/bpc-api-route.service';
import BPCApiRouteHelper from '@core/helpers/bpc-api-route.helper';
import { ApiRouteType } from '@core/interfaces/core-services';

export default class BPCStoreService extends BPCAbstractRequestService {
  public storage: object = {};
  protected $bpcRouter: BPCApiRouteService;
  protected $bpcApiRouteHelper: BPCApiRouteHelper;

  constructor() {
    super();
    this.$bpcRouter = new BPCApiRouteService();
    this.$bpcApiRouteHelper = new BPCApiRouteHelper();
  }

  get(path: string, config?: object): Observable<BPCGenericApiResponse> {
    const pathSplitted = path.split('/');
    const entity = pathSplitted[2];
    if (pathSplitted[3]) {
      const id = pathSplitted[3];
      const result = {
        data: this.getEntityStorage(entity).find(element => element.provisional_id == id),
      };
      return of(result);
    } else {
      const result = {
        data: this.getEntityStorage(entity),
        links: null,
        meta: null,
      };
      return of(result);
    }
  }

  delete(path: string, config?: object): Observable<BPCGenericApiResponse> {
    const pathSplitted = path.split('/');
    const entity = pathSplitted[2];
    const id = pathSplitted[3];
    const entityStorage = this.getEntityStorage(entity);
    for (const i in entityStorage) {
      if (entityStorage[i].provisional_id == id) {
        entityStorage.splice(parseInt(i), 1);
      }
    }
    return of(null);
  }

  post(
    path: string,
    body?: object,
    config?: object,
    apiRouteType?: ApiRouteType,
    withDraft?: boolean,
  ): Observable<BPCGenericApiResponse> {
    const pathSplitted = path.split('/');
    const entity = pathSplitted[2];
    const entityStorage = this.getEntityStorage(entity);
    body['provisional_id'] = entityStorage.length + 1;
    if (withDraft) {
      return this.getDraftFromBackend(entity, entityStorage, 'post', body, config);
    } else {
      entityStorage.push(body);
      const result = {
        data: body,
      };
      return of(result);
    }
  }

  postWithMedia(path: string, body?: object): Observable<BPCGenericApiResponse> {
    return this.post(path, body);
  }

  put(
    path: string,
    body?: object,
    config?: object,
    apiRouteType?: ApiRouteType,
    withDraft?: boolean,
  ): Observable<BPCGenericApiResponse> {
    const pathSplitted = path.split('/');
    const entity = pathSplitted[2];
    const id = pathSplitted[3];
    const entityStorage = this.getEntityStorage(entity);
    body['provisional_id'] = id;
    if (withDraft) {
      return this.getDraftFromBackend(entity, entityStorage, 'put', body, config);
    } else {
      for (const i in entityStorage) {
        if (entityStorage[i].provisional_id == id) {
          entityStorage[i] = body;
        }
      }
      const result = {
        data: body,
      };
      return of(result);
    }
  }

  putWithMedia(path: string, body?: object): Observable<BPCGenericApiResponse> {
    return this.put(path, body);
  }
  set(entity: string, items: AnyEntity[]): void {
    this.storage[entity] = items;
  }
  clear(entity: string): void {
    this.storage[entity] = [];
  }

  private getEntityStorage(entity: string): any[] {
    return this.storage[entity];
  }

  private getDraftFromBackend(
    entity: string,
    entityStorage: any[],
    method: string,
    body?: object,
    config?: object,
  ): Observable<BPCGenericApiResponse> {
    const apiEntityPath =
      this.$bpcRouter.getApiBaseUrl() + '/' + this.$bpcApiRouteHelper.getEntityPath(entity);
    const promise = axios.post(apiEntityPath + '/draft', body, config);
    return new Observable(observer => {
      promise
        .then(response => {
          if (method === 'post') {
            entityStorage.push(response.data);
          } else {
            for (const i in entityStorage) {
              if (entityStorage[i].provisional_id == response.data.provisional_id) {
                entityStorage[i] = response.data;
              }
            }
          }

          observer.next(response.data);
          observer.complete();
        })
        .catch(error => {
          observer.error(error);
        });
    });
  }
}
